import React, { forwardRef } from 'react';
import type { CheckboxProps } from '@mui/material';
import { Checkbox as CheckboxMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => (
  <CheckboxMUI {...omitUndefinedProps(props)} ref={ref} />
));

Checkbox.displayName = 'Checkbox';

export default Checkbox;
